import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteMission, getMissionDetails } from "../../api/missionAPI";
import { useAuthStore } from "../../store/authStore";
import { useMapStore } from "../../store/mapStore";
import { CalculateLatLngDistance, capitalize } from "../../helpers/commonFunction";
import ShowDetailsLabel from "../../components/UI/showDetailsLabel";
import moment from "moment";
import { TrashCan } from "@carbon/icons-react";

const MissionDetails = () => {
    const { missionId } = useParams();
    const navigate = useNavigate();
    const { token, setLoaderState } = useAuthStore((state) => state)
    const { setWaypoints, storeWaypoints } = useMapStore((state) => state)
    const [waypointDistance, setWaypointDistance] = useState(0)
    const [missionDetails, setMissionDetails] = useState([])
    const { data, isLoading } = useQuery([token, missionId], () => getMissionDetails(token, missionId))
    const qClient = useQueryClient();

    useEffect(() => {
        if (data?.data?.data) {
            setMissionDetails(data?.data?.data)
            setWaypoints(data?.data?.data?.waypoints)
        }
    }, [data])

    useEffect(() => {
        if (isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [isLoading])

    const deleteMissionQuery = useMutation({
        mutationFn: deleteMission,
        onSuccess: () => {
            // refetch on submit
            qClient.invalidateQueries({ queryKey: "getMissions" });
        },
    });


    const deleteMissionFunc = (missionId) => {
        deleteMissionQuery.mutate({ missionId, token });
    }

    useEffect(() => {
        if (deleteMissionQuery?.error) {
            toast.error(deleteMissionQuery?.error?.response?.data?.message)
        }

        if (deleteMissionQuery.data?.data?.success) {
            toast.success(deleteMissionQuery.data?.data?.message)
        }

        if (isLoading || deleteMissionQuery.isLoading) {
            setLoaderState(true)
        } else {
            setLoaderState(false)
        }
    }, [isLoading, deleteMissionQuery.isLoading, deleteMissionQuery.error])

    const calculateDistance = (latLngArray) => {
        let distance = 0;
        if (latLngArray?.length > 0) {
            for (let index = 0; index < latLngArray?.length - 1; index++) {
                distance += CalculateLatLngDistance(latLngArray[index]?.lat, latLngArray[index]?.lng, latLngArray[index + 1]?.lat, latLngArray[index + 1]?.lng)
            }
        }
        setWaypointDistance(distance)
    }

    useEffect(() => {
        calculateDistance(storeWaypoints?.length > 0 && storeWaypoints)
    }, [storeWaypoints])

    return (
        <div className="p-4">
            <ToastContainer />
            <div className="flex justify-between items-center">
                <h1 className="text-4xl w-full h-full">Mission Details</h1>
                <div className="flex">
                    <button
                        onClick={() => navigate("/dashboard/mission")}
                        className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                    >
                        View Missions
                    </button>
                    <button
                        onClick={() => { deleteMissionFunc(missionId); navigate("/dashboard/mission") }}
                        className="bg-red-500 flex text-white whitespace-nowrap ml-4 p-4 px-2 text-md rounded-xl"
                    >
                        Delete
                    </button>

                </div>
            </div>
            <br />
            <hr />
            <div>
                <form
                    className="grid grid-cols-3 gap-2 mt-10"
                >
                    <ShowDetailsLabel
                        label="Mission Name"
                        value={missionDetails?.missionName && capitalize(missionDetails?.missionName) || ""}
                    />
                    <ShowDetailsLabel
                        label="Created On"
                        value={missionDetails?.createdOn && moment(missionDetails?.createdOn).format('DD/MM/YYYY') || ""}
                    />
                    <ShowDetailsLabel
                        label="Total Distance"
                        value={`${waypointDistance?.toFixed(2)}km` || ""}
                    />
                    <ShowDetailsLabel
                        label="Mission Type"
                        value={missionDetails?.missionType && capitalize(missionDetails?.missionType) || ""}
                    />
                </form>
            </div>
            <div className="mt-6">
                <ShowDetailsLabel
                    label="waypoints"
                />
                <table className="text-left w-full">
                    <thead className="bg-gray-400 border-solid flex text-white w-full">
                        <tr className="flex w-full mb-4">
                            <th className="pl-2 pt-2 w-1/3">Latitude</th>
                            <th className="pl-2 pt-2 w-1/3">Longitude</th>
                            <th className="pl-2 pt-2 w-1/3">Altitude</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white font-semibold flex flex-col max-h-screen-1/2 min-h-fit items-center justify-between overflow-y-auto w-full border" style={{ minHeight: "10vh", maxHeight: "50vh" }}>
                        {storeWaypoints?.length > 0 && storeWaypoints?.map((waypoint, index) => {
                            return (
                                <tr className="flex w-full" key={index}>
                                    <td className="p-4 w-1/3 border">{waypoint?.lat}</td>
                                    <td className="p-4 w-1/3 border">{waypoint?.lng}</td>
                                    <td className="p-4 w-1/3 border">{waypoint?.alt}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {/* } */}
        </div>
    )
}

export default MissionDetails;